import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../redux/actions/authActions";

import { MdEmail, MdLock, MdVisibility, MdVisibilityOff } from "react-icons/md";
import ForgotPassword from "./ForgotPassword";
import { useNavigate, useSearchParams } from "react-router-dom";

const Login = () => {
  const dispatch = useDispatch();
  const { loading, user, isAuthenticated } = useSelector((state) => state.auth);

  const [currentView, setCurrentView] = useState("login"); // 'login', 'forgot'
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showPassword, setShowPassword] = useState(false);
  const logo =
    user?.oemPartner?.logo ||
    "https://washi.s3.amazonaws.com/RiskReport360.png";

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  useEffect(() => {
    if (isAuthenticated && user) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, user, navigate]);

  // Clear any residual state on component mount
  useEffect(() => {
    // Clear any previous error states
    setFormData({ email: "", password: "" });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(formData));
  };

  if (currentView === "forgot") {
    return <ForgotPassword onBackToLogin={() => setCurrentView("login")} />;
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src={logo}
            alt={user?.oemPartner?.name || "Almata Logo"}
            loading="lazy"
            className="mb-0"
            height="120"
          />
          <h1 className="login-title">Welcome to Risk Report360</h1>
          <p className="login-subtitle">Sign in to your OEM Partner Account</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-wrapper">
              {/* <MdEmail className="input-icon" /> */}
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              {/* <MdLock className="input-icon" /> */}
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
              </button>
            </div>
            <button 
              type="button"
              className="forgot-password-link"
              onClick={() => setCurrentView('forgot')}
            >
              Forgot Password?
            </button>
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
